import Delta from 'quill-delta';
import getOperationOffset from '../utils/getOperationOffset';
import convertNodeToOperations from '../utils/convertNodeToOperations';
export default function insertNode(op, editor) {
  var parent = editor.value.document.getParent(op.path);
  return new Delta().retain(getOperationOffset(op, editor)).concat(new Delta(convertNodeToOperations(op.node, parent)));
}